import { registerComponent } from '@gig/magic-common';
import GracePeriodModalComponent from './grace-period-modal.vue.js';

var GracePeriodModal = registerComponent(GracePeriodModalComponent);

export { GracePeriodModal };
